import * as React from 'react';
import { Button, Card, Spin, } from 'antd';
import { Progress } from '@ant-design/plots'
import { L } from '../../../../lib/abpUtility';
import { LoadingOutlined, } from '@ant-design/icons';
import Meta from 'antd/lib/card/Meta';

export interface IModuleSelectCardProps {
    defaultIcon: any;
    primaryColor: string;
    secondaryColor: string;
    id: number;

    title: string;
    subTitle: string;
    tinyReports: any;
    cardSelect(input: any): void;
}

export interface IModuleSelectCardState {
    optionsExpanded: boolean;
    isMobile: boolean;
    cellProgress: number;
    cellSize: number;
    currentProfileImage: string;
    actionHeight: string;
}

export class ModuleSelectCard extends React.Component<IModuleSelectCardProps, IModuleSelectCardState> {

    state = {
        cellSize: 0,
        cellProgress: 1,
        optionsExpanded: false,

        isMobile: false,
        actionHeight: '50px',
        currentProfileImage: '_',
    };

    async componentDidMount() {
        if (window.innerWidth >= 550) {
            this.setState({
                isMobile: false
            });
        }
        else {
            this.setState({
                isMobile: true
            });
        }

        window.addEventListener('resize', this.handleResize);

    }


    handleResize = () => {
        if (window.innerWidth >= 550) {
            this.setState({
                isMobile: false
            });
        }
        else {
            this.setState({
                isMobile: true
            });
        }


    }

    handleClickOutside = async () => {
        this.setState({ optionsExpanded: false });
    }

    handleOptionExpand = async () => {
        this.props.cardSelect(this.props.id);
    }

    render() {

        const headerConfig = {
            percent: this.state.cellProgress,
            color: [this.props.secondaryColor, this.props.primaryColor],
        };

        const antIcon = <LoadingOutlined style={{ fontSize: 20, color: this.props.primaryColor }} spin />;

        const defaultImage =
            this.state.currentProfileImage === '' || this.state.currentProfileImage === '_'
                ? this.state.currentProfileImage !== '_'
                    ? <Spin indicator={antIcon}  >{this.props.defaultIcon}</Spin>
                    : this.props.defaultIcon : <img style={{ width: '70px', height: '70px' }}
                        src={this.state.currentProfileImage} />


        return (
            <div>

                <div>
                    <Card className="font-face-gm" bodyStyle={{ paddingBottom: '10px', height: '65px' }} bordered={true}
                        hoverable={true} style={{ borderColor: '#e9eaec', borderWidth: '2px', paddingBottom: '0px' }}

                        cover={
                            [this.state.isMobile === false ? (
                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress height={25} autoFit={true} style={{ marginTop: '-12px', width: '96%' }} {...headerConfig} /></div>
                            ) : null]}
                    >

                        {this.state.isMobile === true ? (
                            <div >

                                <div>
                                    <div>
                                        <div style={{ float: 'right', }}><Button className="font-face-gm"
                                            onClick={this.handleOptionExpand}
                                            style={{
                                                minWidth: '75px',
                                                borderColor: this.props.primaryColor,
                                                color: this.props.primaryColor
                                            }} type="default">
                                            {L('Select')}
                                        </Button></div></div>
                                </div>



                                <Meta className="font-face-gm" title={<div style={{ fontSize: '0.9em', paddingBottom: '0px', marginBottom: '0px' }}>{this.props.title}</div>}
                                    avatar={defaultImage}
                                />


                            </div>
                        ) : (
                            <div >

                                <div>
                                    <div>
                                        <div style={{ float: 'right', }}><Button className="font-face-gm"
                                            onClick={this.handleOptionExpand}
                                            style={{
                                                minWidth: '75px',
                                                borderColor: this.props.primaryColor,
                                                color: this.props.primaryColor
                                            }} type="default">
                                            {L('Select')}
                                        </Button></div></div>
                                </div>



                                <Meta className="font-face-gm" title={<div style={{ fontSize: '1.4em', paddingBottom: '0px', marginBottom: '0px' }}>{this.props.title}</div>}
                                    avatar={defaultImage}
                                />


                            </div>
                        )}


                    </Card>
                </div>
            </div>
        );
    }
}

export default ModuleSelectCard;
